
import ApiService from "@/core/services/api.service";


export const SET_LISTA_FATURA = "setListIngresso";
export const SET_LISTA_FATURA_REV = "setListIngressoRev";
export const SET_FATURA = "setIngresso";
export const SET_ROTA = "setRota"
export const SET_MESSAGE_ALERT = 'setMensagem'




const actions = {
    //evento
    async create_fatura(context, value) {

        await ApiService.post('fatura', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },




    async update_fatura(context, value) {

        await ApiService.put('fatura/'+value.id,value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async listar_faturas(context,value) {
        await ApiService.get('fatura/'+value)
            .then(response => {
                context.commit(SET_LISTA_FATURA, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },

    async bloquear_fatura(context, value) {


        await ApiService.delete("fatura/" + value.id)
          .then((response) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "success",
              message: response.data,
            })
          )
          .catch((error) =>
            context.commit(SET_MESSAGE_ALERT, {
              tipo: "error",
              message: error.response.data,
            })
          );
    
    
   
        context.commit(SET_LISTA_FATURA_REV, value)
    
    
      },

      set_rota(context, value) {
        context.commit(SET_ROTA,value)
      },

      async create_fatura_evento_site(context, value) {

        await ApiService.put('evento/produtor/fatura/'+value.id, value.form)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },
    async novo_lote(context, value) {

        await ApiService.post('fatura/lote/'+value.id, value.form)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    

};
const getters = {};

const mutations = {
    [SET_LISTA_FATURA](state, value) {
        state.lista_faturas = value;
    },
    [SET_LISTA_FATURA_REV](state, value) {
        state.lista_faturas = state.lista_faturas.filter(
            (fatura) => fatura.id !== value.id
        );
    },
    [SET_FATURA](state, value) {
        state.evento = value;
    },
    [SET_ROTA](state,value){
        state.rota = value
    },
    [SET_MESSAGE_ALERT](state, value) {
      
        let customMessage;
        if (typeof value.message === "object") {
    
          customMessage = value.message.msg;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.msg,
        };
      },

};

const state = {
    lista_faturas: [],
    lista_faturas_Evento: [],
    evento:{},
    mensagem_alert: "",
    rota:"",

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
